import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Inject,
  Input,
} from '@angular/core';
import {TISA_ICONS_PATH} from './icon.providers';
import {Icon} from './icon';

@Component({
  selector: 'tisa-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IconComponent {
  @HostBinding('class')
  readonly className = 'inline-block h-[1em] w-[1em]';

  @Input() icon: Icon | undefined;

  get src(): string {
    return `${this.iconPath}/${this.icon}.svg`;
  }

  constructor(@Inject(TISA_ICONS_PATH) readonly iconPath: string) {}
}
